import styled from 'styled-components';
import TaskTable from './TaskTable';

const StyledTaskTable = styled(TaskTable)`
  background: var(--background);
  color: var(--primaryColor);
  width: 100%;
  height: 100%;
  margin-top: 40px;
  text-align: center;

  .ant-spin-nested-loading > {
    .ant-spin-container > {
      .ant-table > {
        .ant-table-container > {
          .ant-table-content > {
            table > {
              > tr {
                > th {
                  border-color: var(--borderColor);
                }
              }
            }
          }
        }
      }
    }
  }
`;

export {
  StyledTaskTable
}
